
import { Link, Outlet, useLocation } from 'react-router-dom';
import './Dashboard.css'
import { FaBlog } from 'react-icons/fa';
import { RiFeedbackLine } from 'react-icons/ri';
import { BsArrow90DegLeft } from 'react-icons/bs';
const Dashboard = () => {

    const location = useLocation();

    return (
        <div class="drawer drawer-mobile">
        <input id="dashboard-sidebar" type="checkbox" class="drawer-toggle" />
        <div class="drawer-content">
            

{/* dashboard button  */}
        <div className="flex-none lg:hidden">
  <label htmlFor="dashboard-sidebar" className="btn btn-square btn-ghost flex items-center">
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" className="inline-block w-6 h-6 stroke-current">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 6h16M4 12h16M4 18h16"></path>
    </svg>
  </label>
</div>

            {/* <h2 className='text-2xl font-bold text-purple-500'>Welcome to your Dashboard</h2> */}
            <Outlet></Outlet>
        </div>
  



        <div className="drawer-side">
      <label htmlFor="dashboard-sidebar" className="drawer-overlay"></label>
      <ul className="menu p-0  overflow-y-auto w-48 shadow-2xl bg-[#111827] relative -z-50 text-white transition-all duration-300 border-none">
        <li className='back-home' style={{marginBottom: "-10px", marginTop:"20px"}}>
          <Link
            to="/"
            className=""
          >
           <BsArrow90DegLeft/>
          
          </Link>
        </li>
        <li>
          <Link
            to="/dashboard"
            className={`relative flex items-center h-12 focus:outline-none mt-8 ${
              location.pathname === "/dashboard" ? "bg-primary" : ""
            } hover:bg-primary dark:hover:bg-gray-600 text-white hover:text-white-800 border-l-4 border-transparent hover:border-orange-500 dark:hover:border-gray-800 px-4`}
          >
            <svg
              className="w-6 h-6"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6"
              ></path>
            </svg>
            <span className="ml-3 text-sm">Dashboard</span>
          </Link>
        </li>
        <li>
          <Link
            to="/dashboard/allProject"
            className={`relative flex items-center h-12 focus:outline-none ${
              location.pathname === "/dashboard/allProject"
                ? "bg-primary"
                : ""
            } hover:bg-primary dark:hover:bg-gray-600 text-white hover:text-white-800 border-l-4 border-transparent hover:border-orange-500 dark:hover:border-gray-800 px-4`}
          >
            <svg
              className="w-6 h-6"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M20 13V6a2 2 0 00-2-2H6a2 2 0 00-2 2v7m16 0v5a2 2 0 01-2 2H6a2 2 0 01-2-2v-5m16 0h-2.586a1 1 0 00-.707.293l-2.414 2.414a1 1 0 01-.707.293h-3.172a1 1 0 01-.707-.293l-2.414-2.414A1 1 0 006.586 13H4"
              ></path>
            </svg>
            <span className="ml-3 text-sm">All Projects</span>
          </Link>
        </li>
        <li>
          <Link
            to="/dashboard/addProject"
            className={`relative flex items-center h-12 focus:outline-none ${
              location.pathname === "/dashboard/addProject" ? "bg-primary" : ""
            } hover:bg-primary dark:hover:bg-gray-600 text-white hover:text-white-800 border-l-4 border-transparent hover:border-orange-500 dark:hover:border-gray-800 px-4`}
          >
            <svg
              className="w-6 h-6"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M12 6v6m0 0v6m0-6h6m-6 0H6"
              ></path>
            </svg>
            <span className="ml-3 text-sm">Add Project</span>
          </Link>
        </li>
        <li>
          <Link
            to="/dashboard/updateProject"
            className={`relative flex items-center h-12 focus:outline-none ${
              location.pathname === "/dashboard/updateProject"
                ? "bg-primary"
                : ""
            } hover:bg-primary dark:hover:bg-gray-600 text-white hover:text-white-800 border-l-4 border-transparent hover:border-orange-500 dark:hover:border-gray-800 px-4`}
          >
            <svg
              className="w-6 h-6"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M9 5l7 7-7 7"
              ></path>
            </svg>
            <span className="ml-3 text-sm">Update Project</span>
          </Link>
        </li>
        <li>
          <Link
            to="/dashboard/blogs"
            className={`relative flex items-center h-12 focus:outline-none ${
              location.pathname === "/dashboard/blogs"
                ? "bg-primary"
                : ""
            } hover:bg-primary dark:hover:bg-gray-600 text-white hover:text-white-800 border-l-4 border-transparent hover:border-orange-500 dark:hover:border-gray-800 px-4`}
          >
         <FaBlog/>
            <span className="ml-3 text-sm">Featured Blogs</span>
          </Link>
        </li>
        <li>
          <Link
            to="/dashboard/users-feedback"
            className={`relative flex items-center h-12 focus:outline-none ${
              location.pathname === "/dashboard/users-feedback"
                ? "bg-primary"
                : ""
            } hover:bg-primary dark:hover:bg-gray-600 text-white hover:text-white-800 border-l-4 border-transparent hover:border-orange-500 dark:hover:border-gray-800 px-4`}
          >
         <RiFeedbackLine/>
            <span className="ml-3 text-sm">Users Feedback</span>
          </Link>
        </li>
      </ul>
    </div>


    </div>
    );
};

export default Dashboard;